module.exports = __webpack_public_path__ + "static/media/article3.04247b93.jpg";